{
  "footer": {
    "alreadyPartner": "Bereits Partner?",
    "back": "Zurück",
    "letsgo": "Los geht's!",
    "login": "Anmelden",
    "next": "Weiter",
    "readMore": "Mehr erfahren",
    "signUp": "Anmelden"
  },
  "formErrors": {
    "address": "Die Adresse kann nicht gefunden werden. Bitte eine andere auswählen",
    "businessName": "Dieser Name ist nicht verfügbar. Bitte einen anderen auswählen",
    "email": "Diese E-Mail Adresse wird schon benutzt",
    "verificationCode": "Code nicht gültig",
    "turnstileToken": "Sicherheitscheck fehlgeschlagen. Bitte erneut versuchen."
  },
  "global": {
    "title": "Bei Treatwell anmelden"
  },
  "input": {
    "businessName": {
      "invalid": "Salon name ist zu lang",
      "label": "Salon Name",
      "required": "Benötigt"
    },
    "businessSegment": {
      "aesthetics": "Ästhetik",
      "barber": "Barber",
      "beautician": "Kosmetik",
      "hair-removal": "Haarentfernung",
      "hairdresser": "Friseur",
      "massage": "Massage",
      "nails": "Nägel",
      "primary": "Hauptkategorie",
      "required": "Mindestens eins auswählen",
      "spa": "Spa"
    },
    "businessType": {
      "dedicatedSpaceCheckbox": "Ich bestätige, dass ich einen eigenen und seperaten Raum für meinen Salon habe",
      "home": "Home based <0>- Ihre Kunden kommen zu Ihnen nachhause</0>",
      "mobile": "Mobile <0>- Sie gehen zu Ihren Kunden nachhause</0>",
      "mobileCheckbox": "Ich möchte Treatwell NUR als Buchhungssoftware und NICHT als Marktplatz nutzen.",
      "mobileMessage": "Leider kann unser Marktplatz aufgrund von Einschränkungen nur Unternehmen mit einer festen Adresse präsentieren.",
      "required": "Eine Option auswählen",
      "shop": "Salon <0>- Ihre Kunden kommen zu Ihnen im Laden</0>"
    },
    "city": {
      "invalid": "Stadt ist zu lang",
      "label": "Stadt",
      "required": "Benötigt"
    },
    "country": {
      "label": "Land",
      "required": "Benötigt"
    },
    "email": {
      "invalid": "Ungültig",
      "label": "E-Mail Adresse",
      "required": "Benötigt"
    },
    "firstName": {
      "invalid": "Bitte keine Sonderzeichen verwenden",
      "label": "Vorname",
      "required": "Benötigt"
    },
    "lastName": {
      "invalid": "Bitte keine Sonderzeichen verwenden",
      "label": "Nachname",
      "required": "Benötigt"
    },
    "marketing": {
      "label": "Ich möchte Newsletter per E-Mail erhalten, um meinen Salon mithilfe von Experten zu verbessern."
    },
    "password": {
      "hint": "Mindestens 8 Zeichen",
      "invalid": "Das Passwort benötigt mindestens 8 Zeichen",
      "label": "Passwort",
      "required": "Benötigt",
      "rules": {
        "error-messages": {
          "password-too-short": "Bitte gebe mindestens {{length}} Zeichen ein.",
          "password-too-long": "Huch! Ihr Passwort darf nicht länger als {{length}} Zeichen sein.",
          "password-needs-uppercase": "Dein Passwort muss einen Großbuchstaben enthalten.",
          "password-needs-lowercase": "Dein Passwort muss einen Kleinbuchstaben enthalten."
        }
      }
    },
    "phoneNumber": {
      "invalid": "Telefonnummer nicht gültig",
      "label": "Telefonnummer",
      "required": "Benötigt"
    },
    "postalCode": {
      "invalid": "Postleitzahl ist zu lang",
      "label": "Postleitzahl",
      "required": "Benötigt"
    },
    "privacy": {
      "label": "Mit der Anmeldung für das Freemium-Konto erklären Sie sich mit unserer <0›Datenschutzrichtlinie‹/0> und den Allgemeinen Geschäftsbedingungen auf unserer <1>Website</1> einverstanden."
    },
    "searchBusiness": {
      "label": "Salon suchen"
    },
    "street": {
      "invalid": "Adresse ist zu lang",
      "label": "Adresse",
      "required": "Benötigt"
    }
  },
  "salesMode": {
    "enterPassword": "",
    "invalidPassword": "Passwort nicht gültig"
  },
  "stepContext": {
    "attractNewClients": "Gewinnen Sie neue Kunden",
    "buildRelationships": "Bauen Sie noch bessere Beziehungen zu Ihren Kunden auf",
    "growBusiness": "Lassen Sie Ihr Unternehmen wunderschön wachsen",
    "manageAppointments": "Verwalten Sie alle Ihre Termine unterwegs",
    "prompt": "Sie sind nur ein paar einfache Schritte (und etwa 3 Minuten) davon entfernt, sich über 75.000 Salons anzuschließen, die ihr Geschäft einfach verwalten, ihre Kundenbasis vergrößern und ihren Umsatz steigern.<br /><br />Mit Treatwell werden Sie in der Lage sein:",
    "prompt2": "...und vieles mehr",
    "title": "<0>Jetzt Treatwell nutzen</0> - Europas größte Plattform für Friseur- und Schönheitssalons - es war noch nie so einfach."
  },
  "stepCounter": {
    "step0": "Schritt 1",
    "step1": "Schritt 1",
    "step2": "Schritt 2",
    "step3": "Schritt 3",
    "step4": "Schritt 4",
    "step5": "Glückwünsch"
  },
  "stepEmailVerification": {
    "rateLimited": "Sie haben zu viele Codes angefordert. Bitte verwenden Sie den Code, den wir Ihnen bereits per E-Mail geschickt haben, oder versuchen Sie es in ein paar Minuten erneut.",
    "resend": "Erneut senden",
    "subTitle1": "Geben Sie den Code ein, um Ihre Anmeldung abzuschließen.",
    "subTitle2": "Code nicht erhalten?",
    "title": "<0>Fast fertig,</0> wir haben Ihnen eine E-Mail mit einem 6-stelligen Code geschickt!"
  },
  "stepError": {
    "accountCreation": "Account wird erstellt",
    "body": "Wir haben ein Problem.\\nBitte warten Sie eine Minute und versuchen Sie es noch einmal.",
    "bodyWithError": "Wir haben Probleme mit {{Grund}}.\\nBitte warten Sie eine Minute und erneut versuchen.",
    "button": "Erneut versuchen",
    "title": "Ups, etwas ist schiefgelaufen."
  },
  "stepFinal": {
    "joke1Punchline": "Einen Shampudel!",
    "joke1Setup": "Welchen Hund besitzt ein Friseur?",
    "joke2Punchline": "Das war eine entspannende Angelegenheit!",
    "joke2Setup": "Was sagt der Masseur zu seinem Kunden nach der Sitzung?",
    "joke3Punchline": "Sie feilen an der Beziehung!",
    "joke3Setup": "Was macht ein Nagelstudio mit schlechten Kunden?",
    "joke4Punchline": "Weil sie immer eine glänzende Leistung abliefern!",
    "joke4Setup": "Warum sind Beautysalons so erfolgreich?",
    "joke5Punchline": "",
    "joke5Setup": "",
    "subTitle": "",
    "title": "Danke, lassen Sie uns Ihr Profil erstellen!<br />Geben Sie uns <0>zwei Minuten...</0>"
  },
  "stepFinalRedirectLogin": {
    "alternativeButton": "Ihr Konto erstellen",
    "alternativeMessage": "Verwenden Sie dasselbe Unternehmen, um einen neuen Standort anzumelden?",
    "button": "Bei Treatwell einloggen",
    "message": "<0>Gute Nachrichten!</0> Ihr Unternehmen ist bereits bei Treatwell registriert."
  },
  "stepFourForm": {
    "prompt1": "Wir werden diese Informationen verwenden, um Ihr Konto einzurichten und Sie bei Bedarf zu kontaktieren",
    "title": "Erzählen Sie uns von sich"
  },
  "stepOneForm": {
    "prompt1": "Suchen oder Ihren Salon eingeben",
    "title": "Erzählen Sie uns von Ihrem Salon"
  },
  "stepOneSearch": {
    "addManually": "Ihre Adresse kann nicht gefunden werden? <0>Manuell hinzufügen</0>",
    "prompt1": "Geben Sie Ihren Salonname ein",
    "title": "Erzählen Sie uns von Ihrem Salon"
  },
  "stepThreeForm": {
    "title": "Welche Art von Salon haben Sie?"
  },
  "stepTwoForm": {
    "prompt1": "Wählen Sie alle zutreffenden Kategorien aus, Ihre Hauptkategorie zuerst",
    "title": "Welche Services bieten Sie an?"
  },
  "stepTurnstile": {
    "title": "Fast geschafft!",
    "description": "Bitte den Sicherheitscheck unten abschließen, um sich anzumelden.",
    "loading": "Sicherheitscheck wird geladen…",
    "validationError": "Bitte den Sicherheitscheck abschließen"
  }
}
